var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.closeModal,
        printStyle: _vm.printStyle,
        title: _vm.title,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__title",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-lock" }),
          _vm._v("\n        Залоги\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "zalogModalContent",
          staticClass: "modal__body",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          !_vm.isLoading && _vm.list.length
            ? _c("zalog-table", {
                attrs: {
                  inModal: "",
                  list: _vm.list,
                  actualDate: _vm.actualDate,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading ? _c("loading") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__footer",
          attrs: { slot: "modalFooter" },
          slot: "modalFooter",
        },
        [
          _vm.pagination
            ? _c("pagination", {
                attrs: {
                  paginationObj: _vm.pagination,
                  getNewContent: _vm.nextPage,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }